interface ConnectButtonProps {
  onClick: () => void
  disabled: boolean
  status: 'idle' | 'starting' | 'redirecting' | 'error'
}

const ConnectButton = ({ onClick, disabled, status }: ConnectButtonProps) => {
  const getButtonText = () => {
    switch (status) {
      case 'idle':
        return 'Connect QuickBooks'
      case 'starting':
        return 'Preparing...'
      case 'redirecting':
        return 'Redirecting to QuickBooks...'
      case 'error':
        return 'Try Again'
      default:
        return 'Connect QuickBooks'
    }
  }

  const isLoading = status === 'starting' || status === 'redirecting'

  return (
    <button 
      className="connect-button" 
      onClick={onClick} 
      disabled={disabled}
    >
      {isLoading && <div className="spinner" />}
      {getButtonText()}
    </button>
  )
}

export default ConnectButton